export default __webpack_public_path__ + "static/sequence-logo-5f89221861c92c7ecb7b0d78a9b3aade.png";